import React, { useState } from 'react';
import styles from './review.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { addCVFilterStep, addCVReviewStep, addExternalAssessmentStep, addQuizStep, addReferenceCheckStep, addCustomEvaluationStep, addOneWayInterviewStep } from '../../../../../../services/util/hiringpipeline/steps';
import { addInterviewStep } from '../../../../../../services/util/hiringpipeline/steps';

const Review = (props) => {

    const [state, setState] = useState(false);



    const submitDetails = async () => {
        setState(true)
        if (props.values.stageType === 10) {

            let respond = await addCVFilterStep(props.values.pipeline, props.values.stageName, props.values.keywordCount, props.values.keywords);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 20) {

            let userIDArray = [];
            props.values.reviewers.forEach(element => {
                userIDArray.push(element._id)
            });

            let respond = await addCVReviewStep(userIDArray, props.values.pipeline, props.values.stageName, props.values.description, props.values.numReviewer, props.values.score);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();

            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 30) {
            let respond = await addInterviewStep(props.values.pipeline, props.values.stageName, props.values.description, props.values.score, props.values.interview_guidelines_to_candidate);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 40) {

            let userIDArray = [];
            userIDArray.push(props.values.assessment_reviewers._id)

            let respond = await addExternalAssessmentStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.assessment_body, props.values.assessment_exp_date);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 50) {
            let respond = await addQuizStep(props.values.pipeline, props.values.stageName, props.values.score, props.values.quiz_template.quiz_template_id, props.values.quiz_exp_date);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            } else {
                setState(false)
            }
        } if (props.values.stageType === 60) {

            let userIDArray = [];
            userIDArray.push(props.values.reference_check_reviewers._id)

            let respond = await addReferenceCheckStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } if (props.values.stageType === 70) {

            let userIDArray = [];
            userIDArray.push(props.values.custom_evaluation_reviewers._id)

            let respond = await addCustomEvaluationStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.custom_evaluation_description);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        }
        if (props.values.stageType === 80) {

            let userIDArray = [];
            userIDArray.push(props.values.one_way_interview_reviewers._id)

            let respond = await addOneWayInterviewStep(props.values.pipeline, props.values.stageName, props.values.description, userIDArray, props.values.score, props.values.interview_exp_in, props.values.one_way_interview_template.one_way_interview_template_id);
            if (respond.success === true) {
                setState(false)
                props.getPipelineValues();
                props.handleClose();
            }
            else {
                setState(false)
            }
        } else {
            setState(false)
        }
    }

    return (
        <div>
            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Name&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.stageName}</span>
                    </Col>
                </Row>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Stage&nbsp;Type&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.stageType === 10 ? 'Auto CV Filter' : props.values.stageType === 20 ? 'CV Review' : props.values.stageType === 30 ? 'Interview' : props.values.stageType === 40 ? 'External Assessment' : props.values.stageType === 50 ? 'Quiz' : props.values.stageType === 60 ? 'Reference Check' : props.values.stageType === 70 ? 'Custom Evaluation' : props.values.stageType === 80 ? 'One Way Interview' : ''}</span>
                    </Col>
                </Row>

                {
                    (props.values.stageType === 20) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>
                                {props.values.reviewers.map((value, index) => (
                                    <p className="mb-1" key={index}><i className="fas fa-circle"></i>&nbsp;{value.user_id.email}&nbsp;-&nbsp;{value.user_id.first_name + ' ' + value.user_id.last_name}</p>
                                ))
                                }
                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 40) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.assessment_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.assessment_reviewers.user_id.first_name + ' ' + props.values.assessment_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 60) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.reference_check_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.reference_check_reviewers.user_id.first_name + ' ' + props.values.reference_check_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 70) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.custom_evaluation_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.custom_evaluation_reviewers.user_id.first_name + ' ' + props.values.custom_evaluation_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 80) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Interview&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.one_way_interview_template.template_name}</span>
                        </Col>
                    </Row>
                }

                {
                    (props.values.stageType === 80) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Reviewers&nbsp;:</span><br />
                            <span className={styles.rowValues}>

                                <p className="mb-1" ><i className="fas fa-circle"></i>&nbsp;{props.values.one_way_interview_reviewers.user_id.email}&nbsp;-&nbsp;{props.values.one_way_interview_reviewers.user_id.first_name + ' ' + props.values.one_way_interview_reviewers.user_id.last_name}</p>

                            </span>
                        </Col>
                    </Row>
                }

                {props.values.stageType === 20 &&
                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>No&nbsp;Of&nbsp;Reviewers&nbsp;Per&nbsp;CV&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.numReviewer}</span>
                        </Col>
                    </Row>
                }
                {
                    (props.values.stageType === 50) &&

                    <Row className={styles.pipelineDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Quiz&nbsp;Template&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.quiz_template.name}</span>
                        </Col>
                    </Row>
                }
                {(props.values.stageType === 20 || props.values.stageType === 30 || props.values.stageType === 40 || props.values.stageType === 50 || props.values.stageType === 60 || props.values.stageType === 70 || props.values.stageType === 80) &&
                    <div>
                        {(props.values.stageType != 60) &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Minimum&nbsp;Pass&nbsp;Score&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.score}</span>
                                </Col>
                            </Row>
                        }
                        {(props.values.stageType != 50) &&
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Guideline&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.description ? props.values.description : 'No Review Criteria'}</span>
                                </Col>
                            </Row>}
                    </div>
                }

                {(props.values.stageType === 30) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview&nbsp;Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.interview_guidelines_to_candidate ? props.values.interview_guidelines_to_candidate : 'No Interview Guideline Description'}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 70) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Custom Evaluation Description&nbsp;For&nbsp;Reviewers&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.custom_evaluation_description ? props.values.custom_evaluation_description : 'No Custom Evaluation Description'}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {
                    (props.values.stageType === 10) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Keywords to Scan&nbsp;:</span><br />
                                <span className={styles.rowValues}>
                                    {props.values.keywords.map((value, index) => (
                                        <p className="mb-1" key={index}><i className="fas fa-circle"></i>&nbsp;{value}</p>
                                    ))
                                    }
                                </span>
                            </Col>
                        </Row>

                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Minimum&nbsp;Keyword&nbsp;Count&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.keywordCount}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 40) &&
                    <div>
                        <div>
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assessment&nbsp;:</span>&nbsp;<span className={styles.rowValues}><div dangerouslySetInnerHTML={{ __html: props.values.assessment_body }}></div></span>
                                </Col>
                            </Row>
                            <Row className={styles.pipelineDetailsRow}>
                                <Col xs={12} className="mt-1 mb-1">
                                    <span className={styles.rowSubTitle}>Assesment Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.assessment_exp_date}</span>
                                </Col>
                            </Row>
                        </div>
                    </div>


                }

                {(props.values.stageType === 50) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Quiz Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.quiz_exp_date}</span>
                            </Col>
                        </Row>
                    </div>
                }

                {(props.values.stageType === 80) &&
                    <div>
                        <Row className={styles.pipelineDetailsRow}>
                            <Col xs={12} className="mt-1 mb-1">
                                <span className={styles.rowSubTitle}>Interview Expire After&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.interview_exp_in}</span>
                            </Col>
                        </Row>
                    </div>
                }

                <Row className={styles.actionBtns}>
                    <Col className="pl-0">
                        {<CustomButton
                            id="add_evaluation_go_back_btn"
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}

                        />}
                    </Col>
                    <Col className="pr-0">
                        {<CustomButton
                            id="add_evaluation_submit_btn"
                            buttonType="submit"
                            label="Add Step"
                            type="primaryBtn"
                            disabled={state === true ? true : false}
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            handleClick={() => submitDetails()}
                        />}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Review;
